// Stub for drizzle-zod in client builds
// These functions return Zod schemas with chainable methods like omit(), pick(), etc.
// Note: In production builds, these schemas are already created at build time,
// so these stubs should never actually be called at runtime.

import { z } from 'zod';

function createSchemaStub() {
  // Return a minimal Zod object schema that can be chained
  const stub = z.object({}).passthrough();

  // Add chainable methods that return the stub itself
  (stub as any).omit = (keys: any) => stub;
  (stub as any).pick = (keys: any) => stub;
  (stub as any).extend = (def: any) => stub;
  (stub as any).merge = (def: any) => stub;
  (stub as any).partial = () => stub;
  (stub as any).required = () => stub;

  return stub;
}

export const createInsertSchema = ((schema: any, overrides?: any) => {
  if (typeof window !== 'undefined') {
    console.warn('drizzle-zod createInsertSchema() called in client - this should not happen');
  }
  // If overrides are provided, merge them into the stub
  if (overrides) {
    const stub = z.object(overrides).passthrough();
    (stub as any).omit = (keys: any) => stub;
    (stub as any).pick = (keys: any) => stub;
    return stub;
  }
  return createSchemaStub();
}) as any;

export const createSelectSchema = ((schema: any) => {
  if (typeof window !== 'undefined') {
    console.warn('drizzle-zod createSelectSchema() called in client - this should not happen');
  }
  return createSchemaStub();
}) as any;

